import { ButtonProps, Theme } from '@mui/material';
import { IndeterminateCheckboxIcon, SelectIcon } from '@synergy/theme';
import { PropsWithChildren } from 'react';
import { makeStyles } from '@mui/styles';

import { PoolIconToggleButton } from '../icon-toggle-button/pool-icon-toggle-button';

const useStyles = makeStyles((theme: Theme) => ({
    indeterminate: {
        backgroundColor: theme.palette.primary.main,

        '&:hover': {
            backgroundColor: theme.palette.primary.dark,
            '& circle': {
                fill: theme.palette.primary.dark,
            },
        },
    },
}));

export interface PoolCheckBoxProps extends ButtonProps {
    checked?: boolean;
    indeterminate?: boolean;
}

export const PoolCheckBox = (props: PropsWithChildren<PoolCheckBoxProps>) => {
    const { checked, indeterminate, ...rest } = props;
    const classes = useStyles();

    return (
        <PoolIconToggleButton {...rest} selected={checked} className={indeterminate ? classes.indeterminate : ''}>
            {props.indeterminate ? (
                <IndeterminateCheckboxIcon />
            ) : (
                <SelectIcon stroke={checked ? 'white' : undefined} />
            )}
        </PoolIconToggleButton>
    );
};
